import { Persona } from "@/api/personas.ts";

// Define mappings for tenant-based organizations and logos
const organizationDetails = {
  "q-content": {
    organization: "QStarLabs",
    organization_logo_url:
      "https://storage.googleapis.com/qstar--public-bucket/qstarlabs.png",
  },
  delphi: {
    organization: "Delphi Labs",
    organization_logo_url:
      "https://storage.googleapis.com/qstar--public-bucket/delphi_white.png",
  },
  near: {
    organization: "Near",
    organization_logo_url:
      "https://storage.googleapis.com/qstar--public-bucket/near.png",
  },
  sfermion: {
    organization: "Sfermion",
    organization_logo_url:
      "https://storage.googleapis.com/qstar--public-bucket/sfermion.png",
  },
  // Add more tenants as needed
  default: {
    organization: "QStarLabs Creator",
    organization_logo_url:
      "https://storage.googleapis.com/qstar--public-bucket/qstarlabs.png",
  },
};

// Retrieve organization details based on user.qstarlabs_tenant
function getOrganizationDetailsForTenant(tenant: string) {
  return (
    organizationDetails[tenant as keyof typeof organizationDetails] ||
    organizationDetails.default
  );
}

export function getDefaultPersonaForUser(user: any) {
  const { organization, organization_logo_url } =
    getOrganizationDetailsForTenant(user.qstarlabs_tenant);

  return {
    persona_id: "",
    name: "",
    age: "",
    gender: "",
    occupation: "",
    appearance: {
      height: "",
      weight: "",
      hair_color: "",
      eye_color: "",
    },
    email: "",
    twitter: "",
    instagram: "",
    linktree: "",
    interests: [],
    twitter_lists: [],
    usernames_to_engage: [],
    style: "",
    bio: "",
    persona_worldview: "",
    target_audience: [],
    content_style: "",
    key_message: "",
    persona_objective: "",
    workflow_path: "default_live_workflow.json",
    persona: "",
    initial_prompt: "",
    icon: "",
    deploy_chainlit_bot: true,
    deploy_telegram_bot: false,
    deploy_fastapi_bot: false,
    fastapi_app_url: "",
    enable_image_generation: false,
    enable_twitter_engagement: true,
    enable_instagram_engagement: false,
    public_persona: false,
    organization, // Set organization based on tenant
    organization_logo_url, // Set logo based on tenant
    short_bio: "",
    twitter_data: {},
    persona_video_avatar: "",
    persona_owner: user.qs_username,
    qstarlabs_tenant: user.qstarlabs_tenant,
    avatar_id: "",
    // @ts-expect-error type isn't up to date with server
    web3: {},
  } satisfies Persona;
}
